module.exports = __webpack_public_path__ + "fonts/RenaultLife-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Regular.woff
// module id = 344
// module chunks = 0